import { __ } from '@wordpress/i18n';
import {
  useBlockProps,
  InspectorControls
} from '@wordpress/block-editor';
import {
  PanelBody,
  TextControl,
  SelectControl,
  ToggleControl
} from '@wordpress/components';

export default function Edit({ attributes, setAttributes }) {
  const { text, url, alt, color, class: className, underline } = attributes;

  const blockProps = useBlockProps({
    className: 'wp-block-puroclean-arrow-link'
  });

  return (
    <>
      <InspectorControls>
        <PanelBody title={__('Arrow Link Settings', 'puroclean')} initialOpen={true}>
          <TextControl
            label={__('Link Text', 'puroclean')}
            value={text}
            onChange={(value) => setAttributes({ text: value })}
            placeholder="Learn More"
          />
          
          <TextControl
            label={__('URL', 'puroclean')}
            value={url}
            onChange={(value) => setAttributes({ url: value })}
            placeholder="https://example.com"
          />
          
          <TextControl
            label={__('Alt Text', 'puroclean')}
            value={alt}
            onChange={(value) => setAttributes({ alt: value })}
            placeholder="Description for accessibility"
            help={__('Optional tooltip text that appears on hover', 'puroclean')}
          />
          
          <SelectControl
            label={__('Color', 'puroclean')}
            value={color}
            options={[
              { label: __('Primary (Red)', 'puroclean'), value: 'primary' },
              { label: __('Secondary (Blue)', 'puroclean'), value: 'blue' },
              { label: __('Black', 'puroclean'), value: 'black' },
              { label: __('White', 'puroclean'), value: 'white' }
            ]}
            onChange={(value) => setAttributes({ color: value })}
          />
          
          <TextControl
            label={__('CSS Class', 'puroclean')}
            value={className}
            onChange={(value) => setAttributes({ class: value })}
            placeholder="custom-class"
            help={__('Optional custom CSS classes', 'puroclean')}
          />
          
          <ToggleControl
            label={__('Underline', 'puroclean')}
            checked={underline}
            onChange={(value) => setAttributes({ underline: value })}
            help={__('Show underline on the link text', 'puroclean')}
          />
        </PanelBody>
      </InspectorControls>

      <div {...blockProps}>
        <div className="border border-gray-300 rounded p-4 bg-gray-50">
          <p className="text-sm text-gray-600 mb-2">{__('Arrow Link Preview:', 'puroclean')}</p>
          <div className={`inline-flex items-center text-primary py-3 transition-all duration-500 ${underline ? 'underline' : ''} font-semibold hover:scale-105 group hover:translate-x-[2%]`}>
            <svg className="w-5 h-5 mr-2 group-hover:rotate-45 transition-transform duration-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
            </svg>
            <span className="leading-tight">{text || 'Learn More'}</span>
          </div>
        </div>
      </div>
    </>
  );
}
